import FormSearchBtn from "components/button/formSearch";
import SubHeader from "components/layout/header/subHeader";
import Select from "components/select";
import LodGrdSelect from "components/select/room/lodGrdSelect";
import LodGrpSelect from "components/select/room/lodGrpNoSelect";
import LodNoSelect from "components/select/room/lodNoSelect";
import LodRfdList from "components/tableList/lod/rfd";
import { lodRfdSearchInfoProps } from "interface/lod";
import { lodGrpStatus, lodRfdStatus } from "util/option";

type IProps = {
  memType: "admin" | "manager";
  searchInfo: lodRfdSearchInfoProps;
  handleChange(name: string, value: string): void;
  handleSelect(target: EventTarget & HTMLLIElement): void;
  handleSearch(): void;
  handleReset(): void;
};

const LodRfdView = ({
  memType,
  searchInfo,
  handleChange,
  handleSelect,
  handleReset,
  handleSearch,
}: IProps) => {
  return (
    <>
      <div className="search-form">
        <SubHeader title="숙소환불수수료" add />

        <div className="table-form">
          <table>
            <tbody>
              <tr>
                <th>숙소그룹번호</th>
                <td>
                  <LodGrpSelect
                    option={searchInfo.lodGrpNo}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
                <th>숙소그룹 명</th>
                <td>
                  <input type="text" value="" onChange={(e) => {}} />
                </td>
              </tr>
              <tr>
                <th>숙소번호</th>
                <td>
                  <LodNoSelect
                    option={searchInfo.lodGrpNo}
                    params={searchInfo.lodNo}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
                <th>숙소명</th>
                <td>
                  <input type="text" value="" onChange={(e) => {}} />
                </td>
              </tr>
              <tr>
                <th>숙소등급</th>
                <td>
                  <LodGrdSelect
                    option={searchInfo.lodGrdCd}
                    onSelect={(target) => handleSelect(target)}
                  />
                </td>
                <th>숙소 환불수수료종류</th>
                <td>
                  <Select
                    id=""
                    name=""
                    options={lodRfdStatus}
                    onSelect={() => {}}
                  />
                </td>
              </tr>
              <tr>
                <th>숙소상태</th>
                <td colSpan={1}>
                  <Select
                    id=""
                    name=""
                    options={lodGrpStatus}
                    onSelect={() => {}}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <FormSearchBtn
            handleSearch={handleSearch}
            handleReset={handleReset}
          />
        </div>
      </div>
      <LodRfdList
        searchInfo={searchInfo}
        isLoading={false}
        memType={memType}
        list={[]}
      />
    </>
  );
};

export default LodRfdView;
